import { startApp, type AppHandle } from "./app";
import { applyDocumentLang, initialLang } from "./i18n/index";
import { registerOffline } from "./pwa/register";
import { hasWebGL2 } from "./render/index";
import { showFatal } from "./ui/fatal";
import { mountUpdate } from "./ui/update";

declare global {
  interface Window {
    __planets?: AppHandle;
  }
}

// before anything can fail, so even the error screens use the reader's language
const lang = initialLang();
applyDocumentLang(lang);
// Safari's page pinch zoom, a backstop for the touch-action rules in style.css;
// the scene's own pinch runs on pointer events, which this leaves alone
document.addEventListener("gesturestart", (e) => e.preventDefault());

const canvas = document.getElementById("scene");
const labels = document.getElementById("labels");
const overlay = document.getElementById("overlay");
if (!(canvas instanceof HTMLCanvasElement) || !labels || !overlay) {
  showFatal(lang, "skeleton");
} else if (!hasWebGL2(canvas)) {
  showFatal(lang, "webgl");
} else {
  try {
    const app = startApp(canvas, labels, overlay, lang);
    window.__planets = app;
    if (import.meta.env.PROD) registerOffline(mountUpdate(overlay, app.store).show);
  } catch (err) {
    showFatal(lang, "startup", err);
  }
}
